import React, { useState } from 'react'
import './SNAppCloner.css'
import FileInputWrapper from '../FileInputWrapper/FileInputWrapper'
import { Button } from '@blueprintjs/core'
import Description from '../Description/Description'
import axios from 'axios'
import AppNameInput from '../AppNameInput/AppNameInput'
import AppScopeInput from '../AppScopeInput/AppScopeInput'

const CLONE_APP_URL =
   'https://2aimv6a82m.execute-api.us-east-1.amazonaws.com/serviceNowAppCloner-getClonedApp'

const SNAppCloner = props => {
   const [loading, setLoading] = useState(false)
   const [download, setDownload] = useState(false)
   const [newFileString, setNewFileString] = useState('')
   const [currentAppInfo, setCurrentAppInfo] = useState({
      name: '',
      scope: '',
      prefix: '',
   })
   const [appScope, setAppScope] = useState('')
   const [appName, setAppName] = useState('')
   const [appNameRestrictions, setAppNameRestrictions] = useState(false)
   const [appScopeRestrictions, setAppScopeRestrictions] = useState(false)
   const [appScopeCharRestrictions, setAppScopeCharRestrictions] = useState(
      false
   )
   const [appScopeFieldDirty, setAppScopeFieldDirty] = useState(false)
   const [
      appNameRestrictionsOfMinLen,
      setAppNameRestrictionsOfMinLen,
   ] = useState(false)
   const [
      appScopeRestrictionsOfMinLen,
      setAppScopeRestrictionsOfMinLen,
   ] = useState(false)
   const [file, setFile] = useState({ fileName: '', fileContents: '' })

   const isFormValid = () => {
      if (
         appScope.length > 0 &&
         appName.length > 0 &&
         !appNameRestrictions &&
         !appScopeRestrictions &&
         !appScopeCharRestrictions &&
         !appNameRestrictionsOfMinLen &&
         !appScopeRestrictionsOfMinLen
      )
         return true
      else return false
   }

   const removeSpecialChars = text => {
      const reg = new RegExp(/(\w|\d)/g)
      try {
         text = text.match(reg).join('')
         return text
      } catch {
         return ''
      }
   }

   const handleFileLoad = (fileName, fileContents) => {
      updateCurrentAppInfo(fileContents)
      setFile({ fileName, fileContents })
   }

   const updateCurrentAppInfo = file => {
      const scopeIndex = file.indexOf('<application_scope>') + 19
      const scopeIndexEnd = file.indexOf('</application_scope>')

      const nameIndex = file.indexOf('<application_name>') + 18
      const nameIndexEnd = file.indexOf('</application_name>')

      const scope = file.substring(scopeIndex, scopeIndexEnd)
      const name = file.substring(nameIndex, nameIndexEnd)

      const index = scope.indexOf('_', scope.indexOf('_') + 1)
      const prefix = scope.substring(0, index + 1)

      setCurrentAppInfo({ name, scope, prefix })
      setAppScope(prefix)
   }

   const handleSubmit = () => {
      const { fileName, fileContents } = file
      setLoading(true)
      cloneApp(fileName, fileContents)
   }

   const saveStringAsXmlFile = (filename, text) => {
      let pom = document.createElement('a')
      pom.setAttribute(
         'href',
         'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
      )
      pom.setAttribute('download', filename)

      if (document.createEvent) {
         var event = document.createEvent('MouseEvents')
         event.initEvent('click', true, true)
         pom.dispatchEvent(event)
      } else {
         pom.click()
      }
   }

   const cloneApp = (fileName, fileContents) => {
      const options = {
         headers: { Accept: '*/*' },
      }
      axios
         .post(CLONE_APP_URL, { fileContents, appScope, appName }, options)
         .then(res => {
            setNewFileString(res.data)
         })
         .catch(err => {
            console.warn(err)
         })
         .finally(() => {
            setLoading(false)
            setDownload(true)
         })
   }

   const appScopeChangeHandler = event => {
      let scopeName = event.target.value
      if (scopeName.length <= 18) {
         setAppScopeRestrictions(false)
      } else {
         setAppScopeRestrictions(true)
      }
      const newScopeName = removeSpecialChars(scopeName)
      if (newScopeName !== scopeName) {
         setAppScopeCharRestrictions(true)
      } else {
         setAppScopeCharRestrictions(false)
      }
      if (scopeName.length >= 1) {
         setAppScopeRestrictionsOfMinLen(false)
      } else {
         setAppScopeRestrictionsOfMinLen(true)
      }
      setAppScope(scopeName)
      setAppScopeFieldDirty(true)
   }

   const appNameChangeHandler = event => {
      let appName = event.target.value
      if (appName.length <= 100) {
         setAppNameRestrictions(false)
      } else {
         setAppNameRestrictions(true)
      }
      if (appName.length > 0) {
         setAppNameRestrictionsOfMinLen(false)
      } else {
         setAppNameRestrictionsOfMinLen(true)
      }
      if (!appScopeFieldDirty) {
         let newAppScope = currentAppInfo.prefix + appName.toLowerCase()
         newAppScope = newAppScope.replace(/\s/g, '_')
         newAppScope = removeSpecialChars(newAppScope)

         if (newAppScope.length <= 19) {
            setAppScopeRestrictions(false)
         } else {
            setAppScopeRestrictions(true)
         }
         if (removeSpecialChars(newAppScope) === newAppScope) {
            setAppScopeCharRestrictions(false)
         }
         setAppScope(newAppScope)
      }
      setAppName(appName)
   }

   const buttonActive = isFormValid()

   return (
      <div className="myApp">
         <div className="bp3-callout bp3-intent-danger bp3-icon-info-sign">
         <h4 className="bp3-heading">Warning! This is an experimental functionality. Clone applications on your own risk.</h4>
         Application clone may not work properly, use your own judgement and test it thoroughly.
         </div>
         <p className="introText">Clone a ServiceNow Scoped App</p>
         <Description />

         <form>
            <FileInputWrapper handleFileUpload={handleFileLoad} updateDownload = {()=>{ setDownload(false); setAppName('')}}/>
            <p className="addedText" style={{ marginTop: '15px' }}>
               New application name
            </p>

            <AppNameInput
               inputChangeHandler={appNameChangeHandler}
               value={appName}
               disable={appNameRestrictions || appNameRestrictionsOfMinLen}
            />

            {appNameRestrictions && (
               <p
                  style={{
                     fontSize: '11px',
                     color: 'red',
                     marginBottom: '5px',
                  }}
               >
                  Can be at most 100 characters long
               </p>
            )}

            {appNameRestrictionsOfMinLen && (
               <p style={{ fontSize: '11px', color: 'red' }}>
                  Name is required
               </p>
            )}

            <p className="addedText" style={{ marginTop: '15px' }}>
               New application scope
            </p>

            <AppScopeInput
               inputChangeHandler={appScopeChangeHandler}
               value={appScope}
               disable={
                  appScopeRestrictions ||
                  appScopeRestrictionsOfMinLen ||
                  appScopeCharRestrictions
               }
            />

            {appScopeRestrictions && (
               <p
                  style={{
                     fontSize: '11px',
                     color: 'red',
                     marginBottom: '5px',
                  }}
               >
                  Can be at most 18 characters long
               </p>
            )}

            {appScopeCharRestrictions && (
               <p
                  style={{
                     fontSize: '11px',
                     color: 'red',
                     marginBottom: '5px',
                  }}
               >
                  You can't use special characters
               </p>
            )}

            {appScopeRestrictionsOfMinLen && (
               <p style={{ fontSize: '11px', color: 'red' }}>
                  Scope is required
               </p>
            )}
         </form>

         {!download && (
            <div style={{ marginTop: '20px', textAlign: 'center' }}>
               <Button
                  large
                  type="submit"
                  onClick={handleSubmit}
                  intent="primary"
                  disabled={!buttonActive}
                  loading={loading}
               >
                  Clone {currentAppInfo.name}
               </Button>
            </div>
         )}

         {download && (
            <>
               <p style={{ fontSize: '20px', marginTop: '20px' }}>
                  Application <strong>{currentAppInfo.name}</strong> is cloned
                  successfully.
               </p>
               <Button
                  large
                  intent="success"
                  onClick={() =>
                     saveStringAsXmlFile('CloneApp.xml', newFileString)
                  }
               >
                  Download <strong>{appName}</strong>
               </Button>
            </>
         )}
      </div>
   )
}

export default SNAppCloner
